"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormBase = _interopRequireDefault(require("@components/Form/FormBase"));

var _stylesModule = _interopRequireDefault(require("@components/Form/FormBase/styles.module.scss"));

var _scss = require("@scss");

var _excluded = ["name", "label", "placeholder", "value", "defaultValue", "error", "success", "size", "disabled", "className", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Textarea = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      label = _ref.label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      error = _ref.error,
      success = _ref.success,
      size = _ref.size,
      disabled = _ref.disabled,
      className = _ref.className,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    element: '',
    wrapper: '',
    label: '',
    validator: ''
  } : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_FormBase["default"], {
    classes: {
      element: (0, _scss.cls)(classes['element']),
      wrapper: (0, _scss.cls)(classes['wrapper']),
      label: (0, _scss.cls)(classes['label']),
      validator: (0, _scss.cls)(classes['validator'])
    },
    name: name,
    label: label,
    error: error,
    success: success
  }, /*#__PURE__*/_react["default"].createElement("textarea", _extends({
    ref: ref,
    id: name,
    name: name,
    placeholder: placeholder,
    "aria-label": label ? label : placeholder ? placeholder : ''
  }, value && {
    value: value
  }, defaultValue && {
    defaultValue: defaultValue
  }, disabled && {
    disabled: disabled
  }, {
    className: (0, _scss.cls)(_stylesModule["default"]['form-control'], size && _stylesModule["default"]["form-control-".concat(size)], error && _stylesModule["default"]['is-invalid'], success && _stylesModule["default"]['is-valid'], classes['element'], className)
  }, props)));
});
var _default = Textarea;
exports["default"] = _default;